import React, { useState } from "react";
import { NavLink } from "react-router-dom";

const cardStyle = {
  background: "#ffffff",
  borderRadius: "8px",
  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
  padding: "20px",
  marginBottom: "20px",
};

const teal = "#06d1c6";
const inputStyle = {
  width: "100%",
  padding: "8px 12px",
  border: `1px solid ${teal}`,
  borderRadius: "6px",
  backgroundColor: "#fff",
  color: "#334155",
  fontSize: "14px",
};

export default function PayoutProcess() {
  const [processMonth, setProcessMonth] = useState("02-2026");
  const [category, setCategory] = useState("");
  const [subBroker, setSubBroker] = useState("");
  const [arn, setArn] = useState("");

  const handleView = (e) => {
    e.preventDefault();
    console.log({ processMonth, category, subBroker, arn });
  };

  return (
    <div className="main-content">
      <div className="page-wrapper page-settings">
        <div className="content">
          {/* Breadcrumb and Header */}
          <div className="mb-4" style={cardStyle}>
            <div className="content-page-header content-page-headersplit">
              <h5>Payout Process</h5>
            </div>
            <nav aria-label="breadcrumb" style={{ "--bs-breadcrumb-divider": "none", marginBottom: "15px" }}>
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <NavLink to="/dashboard">Dashboard</NavLink> /
                </li>
                <li className="breadcrumb-item">
                  <NavLink to="/admin/brokerage/income-detail">Brokerage</NavLink> /
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Payout Process
                </li>
              </ol>
            </nav>
          </div>

          {/* Form card */}
          <div style={cardStyle}>
            <p className="text-secondary mb-4" style={{ fontSize: "14px" }}>
              View Commission sub broker wise and Apply Rate. Then Freeze the transaction
            </p>

            <form onSubmit={handleView}>
              <div className="row g-3 mb-4">
                <div className="col-12 col-md-3">
                  <label className="form-label small fw-semibold text-secondary mb-1 d-block">Process Month</label>
                  <input
                    type="text"
                    placeholder="MM-YYYY"
                    value={processMonth}
                    onChange={(e) => setProcessMonth(e.target.value)}
                    style={inputStyle}
                    maxLength={7}
                  />
                </div>
                <div className="col-12 col-md-3">
                  <label className="form-label small fw-semibold text-secondary mb-1 d-block">Category</label>
                  <select value={category} onChange={(e) => setCategory(e.target.value)} style={inputStyle}>
                    <option value="">Select</option>
                  </select>
                </div>
                <div className="col-12 col-md-3">
                  <label className="form-label small fw-semibold text-secondary mb-1 d-block">Sub Broker</label>
                  <input
                    type="text"
                    placeholder="Search Sub Broker..."
                    value={subBroker}
                    onChange={(e) => setSubBroker(e.target.value)}
                    style={inputStyle}
                  />
                </div>
                <div className="col-12 col-md-3">
                  <label className="form-label small fw-semibold text-secondary mb-1 d-block">ARN</label>
                  <select value={arn} onChange={(e) => setArn(e.target.value)} style={inputStyle}>
                    <option value="">Select</option>
                  </select>
                </div>
              </div>

              <div className="text-center">
                <button
                  type="submit"
                  style={{
                    background: teal,
                    color: "#fff",
                    border: "none",
                    padding: "10px 28px",
                    borderRadius: "8px",
                    fontWeight: 600,
                    fontSize: "15px",
                    cursor: "pointer",
                  }}
                >
                  View
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
